module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av295-af9fbb7565597199a31a4fbd0111ecf2.jpg";